module.exports = __webpack_public_path__ + "img/strobeicon512.9949ea19.png";